import { render, staticRenderFns } from "./SecuritySection.vue?vue&type=template&id=4f01032f&"
import script from "./SecuritySection.vue?vue&type=script&lang=js&"
export * from "./SecuritySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports